import useGetProductsAndRelatedDataByQuery from './useGetProductsAndRelatedDataByQuery'

export default useGetProductsAndRelatedDataByQuery
